import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import ErrorIcon from '../../assets/AlertIcons/error-icon-contact.svg';
import CloseIcon from '../SVG/CloseIcon';

const UploadErrorModel = ({
    show,
    onHide,
    data
}) => {

    const handleCloseModel = () => {
        onHide(false);
    };

    return (
        <Modal
            show={show}
            animation={true}
            onHide={handleCloseModel}
            size="lg"
            centered
        >
            <Modal.Body>
                <CloseIcon handleModalClose={handleCloseModel}/>
                <div className="svg-wrapper">
                    <img src={ErrorIcon} />
                </div>
                <Modal.Title as="h3" style={{ margin: '8px 0 16px' }}>
                    Import Contacts Error
                </Modal.Title>

                <Form>
                    <Form.Group>
                        <div>
                        We noticed you tried to import contacts in the incorrect format: 
                            {data && data.map((item) => (
                                item.phone_number + ", "
                            ))}
                        </div>
                    </Form.Group>
                    <Form.Group>
                        <div>
                        To avoid future errors, please make sure all mobile numbers are formatted correctly in Microsoft Excel using either of the following methods:
                            <ol type="1">
                                <li>Using cell NUMBER format, include the country code with special character e.g. Malaysia's mobile number would appear as +60123456789</li>
                                <li>Using cell TEXT format, format all mobile numbers using this formula, (=TEXT(A1,"0.* ### *** ###")</li>
                            </ol>
                        </div>
                    </Form.Group>
                </Form>

            </Modal.Body>
        </Modal>
    );
};

export default UploadErrorModel
